const default_es_images = [
  { src: `/images/Campaigns/campaign_otos_es.jpg`, alt: "image_1" },
  { src: `/images/Campaigns/campaign_2_es.jpg`, alt: "image_2" },
  { src: `/images/Campaigns/campaign_3_es.jpg`, alt: "image_3" },
  { src: `/images/Campaigns/campaign_4_es.jpg`, alt: "image_4" },
];

const default_en_images = [
  { src: `/images/Campaigns/campaign_otos_en.jpg`, alt: "image_1" },
  { src: `/images/Campaigns/campaign_2_en.jpg`, alt: "image_2" },
  { src: `/images/Campaigns/campaign_3_en.jpg`, alt: "image_3" },
  { src: `/images/Campaigns/campaign_4_en.jpg`, alt: "image_4" },
];

const processPromotions = (promotions, locale) => {
  console.log(promotions);
  const promotionitems = promotions[0].promotionitems;
  return promotionitems.map((promotion) => {
    return {
      src: promotion.backgroundImage.url,
      alt: promotion[`description_${locale}`],
      link: promotion.link
    }
  });
}

export default async function getCampaignImages({ locale }) {

  const [global, mx] = await Promise.all([
    fetch(`${process.env.GATSBY_DYNAMIC_CONTENT}/promotions?id=6629a6018ba40c0024543226`).then((res) => res.json()),
    fetch(`${process.env.GATSBY_DYNAMIC_CONTENT}/promotions?id=6629a6208ba40c0024543227`).then((res) => res.json()),
  ]);

  if (global && global.length > 0) {
    return processPromotions(global, locale);
  }

  if (mx && mx.length > 0) {
    return processPromotions(mx, locale);
  }

  return [];
}
